import { render, staticRenderFns } from "./MultiSelectOptionsCard.vue?vue&type=template&id=fa6b1972&scoped=true&"
import script from "./MultiSelectOptionsCard.vue?vue&type=script&lang=js&"
export * from "./MultiSelectOptionsCard.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectOptionsCard.vue?vue&type=style&index=0&id=fa6b1972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6b1972",
  null
  
)

export default component.exports